import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
    {
        field: 'order_number',
        headerName: 'acumatica / pullsheet num',
        flex: 1,
        minWidth: 150,
        editable: false
    }, 
    {
        field: 'customer',
        headerName: 'vendor',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'sku',
        headerName: 'sku',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'quantity',
        headerName: 'quantity',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'build_date',
        headerName: 'build date',
        flex: 1,
        minWidth: 100,
        valueGetter: (params) => {
            if(!params.row.build_date) return "";
            return params.row.build_date.substring(0, 10);
        }, 
        editable: false
    },
    {
        field: 'worker',
        headerName: 'workers',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'group_number',
        headerName: 'group',
        flex: 1,
        minWidth: 50,
        editable: false
    }, 
    {
        field: 'warehouse',
        headerName: 'warehouse',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'reported',
        headerName: 'reported',
        flex: 1,
        minWidth: 50,
        editable: false
    }, 
];

function BuildsTable(props) {

    return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"}>
            <Box className = {props.isMobile ? "mobile-table-box" : "desktop-table-box"}>
                <DataGrid
                    className = {props.isMobile ? "mobile-table" : "desktop-table"}
                    sx = {{ 
                        width: '95%',
                        height: "1000px",
                        '& .red-row': {
                            backgroundColor: '#FAA0A0', 
                            '&:hover': {
                                backgroundColor: '#cc3333',  
                            },
                        },
                    }}
                    rows = {props.builds}
                    getRowId = {(row) => row.id}
                    columns = {columns}
                    rowsPerPageOptions = {[25, 50, 100]}
                    checkboxSelection = {false}
                />
            </Box>
        </Box>
    )

}

export default BuildsTable;